<template>
    <div class="profile-header mb-5" >
        <div class="relative">
            <div class="cover-container rounded-t-lg">
                <div class="header_img lazyload bg-center" ref="headerImg" :data-bg="headerImg">
                    <div class="flex absolute z-20 top-0 right-0 mt-3 mr-3 head_img_btn"></div>
                </div>
            </div>
             <div class="profile-img-container pointer-events-none pl-0 lg:pl-16">
                <div>
                    <vs-avatar v-if="user && user.avatar" class="user-profile-img"
                        :src="user.avatar" size="85px" />
                </div>
            </div>
        </div>
        <div class="flex items-center justify-end flex-wrap profile-header-nav p-4">
            <div class="nav_menu w-full flex-grow sm:flex sm:items-center sm:w-auto md:ml-auto justify-between">
                <h3 class="font-semibold text-base lg:text-2xl mb-3 lg:mb-0 pt-5 lg:pt-0 mt-6 lg:mt-0" >
                    {{fullName(user)}}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
    import userSetting from '@/localNodeModules/setting/user.js'

    export default {
        props:{
            user:{
                type:Object,
            }
        },
        mixins:[userSetting],

        computed:{

            headerImg() {
                if (this.user && this.user.header_picture)
                    return this.user.header_picture.path;
                else
                    return require("@/assets/images/pages/authorization-background.jpg");
            },
        },

    }
</script>


<style  lang="scss" scoped>

    .profile-header {
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);

        .profile-img-container {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: -3.6rem;
            left: 0;
            width: 80%;
            justify-content: space-between;
        }

        .user-profile-img {
            border: 0.3rem solid #fff;
            box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.3);
        }

        .user-latest-image {
            transition: all 0.2s ease-in-out;

            &:hover {
                transform: scale(1.2);
            }
        }

        .profile-header-nav {
            background-color: #fff;
            border-radius: 0 0 0.5rem 0.5rem;
        }

        .header_img {
            border-radius: 0.5rem 0.5rem 0 0;
            min-height: 150px;
            position: relative;
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-size: cover !important;

            &:not(.lazyloaded) {
                background: rgba(0, 0, 0, 0.1);
            }
        }
    }

    @media only screen and (min-width: 901px) {
    .nav_menu {
        padding-left: 12rem;
    }
}
@media only screen and (max-width: 900px) {
    .nav_menu {
        button {
            width: 100%;
        }
    }
}
@media (min-width: 560px) and (max-width: 1455px) {
    .nav_menu {
        padding-left: 11rem;
        button {
            padding: 0.579rem 0.5rem !important;
            font-size: 13px;
        }
        h3 {
            font-size: 1rem !important;
        }
    }
}

</style>
